/** Shared input helpers for Add/Edit Coupon and Generate Bulk Coupon forms. */

export const blockDecimalNumberKeyDown = e => {
  if (["e", "E", "+", "-", "."].includes(e.key)) {
    e.preventDefault()
  }
}

export const wholeNumberInputProps = {
  min: 1,
  step: 1,
  pattern: "[0-9]*",
  onKeyDown: blockDecimalNumberKeyDown,
}

export const sanitizeAlphanumeric = (value, maxLength) =>
  String(value || "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .slice(0, maxLength)

export const sanitizeCouponCode = (value, maxLength) =>
  sanitizeAlphanumeric(value, maxLength).toUpperCase()
